<template>
    <footer>
        <div class="content nunito">
            <div class="top">
                <h2>Subscribete</h2>
                <p>¡No te pierdas nuestras novedades! Suscríbete para recibir las últimas actualizaciones, consejos de marketing y ofertas exclusivas directamente en tu correo.</p>
                <form @submit.prevent="submitSubscription">
                    <div class="column">
                        <input 
                            type="email" 
                            v-model="email"
                            placeholder="Correo electrónico"
                            :disabled="loading"
                            required>
                        <button 
                            type="submit"
                            title="Enviar"
                            :disabled="loading">
                            <i v-if="!loading" class="fa-regular fa-paper-plane"></i>
                            <i v-else class="fa-solid fa-spinner fa-spin"></i>
                            <span>{{ loading ? 'Enviando...' : 'Enviar' }}</span>
                        </button>
                    </div>
                    <!-- Mensaje de éxito/error -->
                    <div v-if="message" :class="['subscription-message', messageType]">
                        {{ message }}
                        <button type="button" @click="clearMessage" class="close-message">
                            <i class="fa-solid fa-times"></i>
                        </button>
                    </div>
                </form>
            </div>
            <div class="down">
                <div class="copyright">
                    &copy; 2025 <span>LR Pro Marketing</span>
                </div>
                <ul class="options">
                    <li><router-link :to="'/terms-of-service'" title="Ir a la página de Terminos de servicios">Terminos
                            de servicios</router-link></li>
                    <li><router-link :to="'/faqs'" title="Ir a la página de Preguntas frecuentes">Preguntas frecuentes</router-link>
                    </li>
                    <li><router-link :to="'/privacy-policy'" title="Ir a la página de Politíca de privacidad">Politíca de privacidad</router-link>
                    </li>
                    <li><router-link :to="'/sitemap'" title="Ir a la pagina del Mapa del sitio">Mapa del sitio</router-link>
                    </li>
                </ul>
                <ul class="social-networks">
                    <li v-for="(s, i) of media" v-bind:key="i">
                        <a :href="s.href" target="_blank" :title="s.name"><i :class="s.icon"></i></a>
                    </li>
                </ul>
            </div>
        </div>
    </footer>
</template>
<script>
import mediaData from "@/data/socialMedia.json";
import apiService from '../config/api.js';

export default {
    name: 'FooterComponent',
    data(){
        return {
            media: mediaData,
            email: '',
            loading: false,
            message: '',
            messageType: 'success'
        }
    },
    methods: {
        async submitSubscription() {
            // Prevenir múltiples envíos
            if (this.loading) return;
            
            this.loading = true;
            this.message = '';
            
            try {
                const subscriptionData = {
                    email: this.email,
                    source: 'footer'
                };
                
                console.log('Enviando suscripción desde footer:', subscriptionData);
                const response = await apiService.submitSubscription(subscriptionData);
                console.log('Respuesta del API:', response);
                
                if (response && response.success) {
                    this.message = response.message || '¡Suscripción exitosa! Gracias por suscribirte.';
                    this.messageType = 'success';
                    this.email = ''; // Limpiar el campo
                    
                    // Auto-ocultar mensaje después de 5 segundos
                    setTimeout(() => {
                        this.clearMessage();
                    }, 5000);
                } else {
                    this.message = response?.error || 'Error al suscribirse. Intenta nuevamente.';
                    this.messageType = 'error';
                }
            } catch (error) {
                console.error('Error submitting subscription:', error);
                this.message = 'Error de conexión. Verifica tu conexión a internet e intenta nuevamente.';
                this.messageType = 'error';
            } finally {
                this.loading = false;
            }
        },
        
        clearMessage() {
            this.message = '';
            this.messageType = 'success';
        }
    }
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/variables.scss';

body.dark-theme footer {
    .content {
        .top {
            h2 {
                color: white;
            }

            p {
                color: #ccc;
            }

            form {

                .column {
                    border: 1px solid #fefefe;
                    background: rgb(239, 239, 239);


                    input {
                        background: rgb(239, 239, 239);
                    }

                    button {

                        background: #111112;

                        &:hover:not(:disabled) {
                            background: #e8505b;
                        }

                        i {}
                    }
                }
                
                .subscription-message {
                    &.success {
                        background-color: rgba(212, 237, 218, 0.9);
                        color: #155724;
                    }
                    
                    &.error {
                        background-color: rgba(248, 215, 218, 0.9);
                        color: #721c24;
                    }
                }
            }
        }

        .down {
            border-top: 0.5px solid #343434;
            color: #e3e3e3;

            .copyright {

                span {
                    color: #e8505b;
                }
            }

            ul.social-networks {
                li {
                    i {
                        color: #6b6b6b;
                    }
                }
            }

            ul {

                li {
                    a {
                        color: #7c818d;

                        &:hover {
                            color: #ffffff;
                        }
                    }

                    i {
                        color: #7c818d;

                        &:hover {
                            color: #ffffff;
                        }
                    }
                }
            }
        }
    }
}

footer {
    width: 100%;
    padding: 40px 0;

    .content {
        width: 100%;
        margin: 0 auto;

        .top {
            max-width: 1280px;
            width:90%;
            text-align: center;
            margin: 0 auto;

            p {
                width: 100%;
                max-width: 400px;
                margin: 0 auto;
                padding-bottom: 20px;
            }

            form {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 15px;

                .column {
                    border: 1px solid #ccc;
                    border-radius: 5px;
                    overflow: hidden;
                    max-width: 400px;
                    width:100%;
                    height: 50px;
                    display: flex;

                    input {
                        height: 100%;
                        flex: 1;
                        border: none;
                        outline: none;
                        padding: 0 20px;
                        
                        &:disabled {
                            opacity: 0.7;
                            cursor: not-allowed;
                        }
                    }

                    button {
                        border-radius: 5px;
                        border: none;
                        background: #111112;
                        color: #f1f1f1;
                        display: flex;
                        gap: 10px;
                        justify-content: center;
                        align-items: center;
                        padding: 0 20px;
                        cursor: pointer;
                        transition: background 0.9s;

                        &:hover:not(:disabled) {
                            background: #03038e;
                            transition: background 0.4s;
                        }
                        
                        &:disabled {
                            opacity: 0.7;
                            cursor: not-allowed;
                        }
                    }
                }
                
                .subscription-message {
                    max-width: 400px;
                    width: 100%;
                    padding: 12px 16px;
                    border-radius: 8px;
                    font-weight: 500;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    
                    &.success {
                        background-color: rgba(212, 237, 218, 0.9);
                        color: #155724;
                        border: 1px solid rgba(195, 230, 203, 0.9);
                    }
                    
                    &.error {
                        background-color: rgba(248, 215, 218, 0.9);
                        color: #721c24;
                        border: 1px solid rgba(245, 198, 203, 0.9);
                    }
                    
                    .close-message {
                        background: none;
                        border: none;
                        color: inherit;
                        cursor: pointer;
                        padding: 4px;
                        border-radius: 4px;
                        transition: background-color 0.2s ease;
                        
                        &:hover {
                            background-color: rgba(0, 0, 0, 0.1);
                        }
                        
                        i {
                            font-size: 12px;
                        }
                    }
                }
            }
        }

        .down {
            border-top: 0.5px solid #f1f1f1;
            color: #6e768e;
            width: 90%;
            margin: 30px auto 0 auto;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            padding: 40px 0 0 0;

            @media (max-width: $breakpoint-lg) {
                gap: 20px 30px;
            }

            @media (max-width: $breakpoint-md) {
                justify-content: center;
                gap: 20px;
            }

            .copyright {
                font-size: 16px;
                font-weight: 600;
                text-wrap: nowrap;

                @media (max-width: $breakpoint-md) {
                    width: 100%;
                    text-align: center;
                    order: 3;
                }

                span {
                    color: rgb(21, 1, 13);
                    font-weight: 900;
                }
            }

            .options {
                display: flex;
                flex-wrap: wrap;

                @media (max-width: $breakpoint-lg) {
                    width: 100%;
                    order: 1;
                    justify-content: center;
                }
            }

            ul.social-networks {
                li {
                    i {

                        color: #3f3f3f;
                    }
                }
            }

            ul {
                display: flex;
                list-style: none;
                gap: 30px;

                li {
                    a {
                        text-decoration: none;
                        color: #7c818d;

                        &:hover {
                            color: #111112;
                        }
                    }

                    i {
                        color: #7c818d;
                        font-size: 24px;

                        &:hover {
                            color: #111112;
                        }
                    }
                }
            }
        }
    }
}
</style>